var LoginGrantType = /* @__PURE__ */ ((LoginGrantType2) => {
  LoginGrantType2["Password"] = "password";
  LoginGrantType2["OTP"] = "otp";
  LoginGrantType2["Google"] = "google";
  return LoginGrantType2;
})(LoginGrantType || {});
export {
  LoginGrantType
};
